
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ServiceImageGallery from "../components/ServiceImageGallery";
import UserAvatar from "../components/UserAvatar";
import {
  FaClock,
  FaMapMarkerAlt,
  FaUser,
  FaUsers,
  FaWheelchair,
  FaCheckCircle,
  FaClipboardList,
  FaCalendarAlt,
} from "react-icons/fa";
import { getServiceAvailablePlaces } from "../utils/serviceUtils";

const ServiceDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [service, setService] = useState(null);
  const [avis, setAvis] = useState([]); 
  const [message, setMessage] = useState("");
  const [showMsg, setShowMsg] = useState(false);
  const [authPromptOpen, setAuthPromptOpen] = useState(false);
  const [quantite, setQuantite] = useState(1);
  const [selectedCreneauIndex, setSelectedCreneauIndex] = useState(0);
  const [placesRestantes, setPlacesRestantes] = useState(0);
  const serviceCapacityValue = (() => {
    const rawCandidates = [
      service?.capaciteMaximale,
      service?.nombrePersonnesMaxAtelier,
    ];

    const picked = rawCandidates.find((value) => {
      const numeric = Number(value);
      return Number.isFinite(numeric) && numeric > 0;
    });

    return picked !== undefined ? Number(picked) : null;
  })();
  //const [loadingAvis, setLoadingAvis] = useState(false);
 // const [note, setNote] = useState(null); // Ajoute cet état
/*
useEffect(() => {
  console.log("Note actuelle :", note);
}, [note]);

*/

  useEffect(() => {
    const fetchServiceAndAvis = async () => {
      try {
        // Charger le service
        const resService = await api.get(`/api/services/${id}`);
        setService(resService.data);
        if (Array.isArray(resService.data?.dateService) && resService.data.dateService.length > 0) {
          setSelectedCreneauIndex(0);
        }

        const backendRemaining = Number(resService.data?.placesRestantes);
        if (Number.isFinite(backendRemaining) && backendRemaining >= 0) {
          setPlacesRestantes(backendRemaining);
        } else {
          const countRes = await api.get(`/api/reservations/count/${id}`);
          const totalPlaces = getServiceAvailablePlaces(resService.data);
          setPlacesRestantes(Math.max(totalPlaces - (countRes.data.count || 0), 0));
        }


        // Charger les avis du service ✅
        const resAvis = await api.get(`/api/avis/service/${id}`);
        setAvis(resAvis.data || []);
      } catch (err) {
        console.error("Erreur lors du chargement :", err);
      }
    };
    fetchServiceAndAvis();
  }, [id]);

  if (!service) return <p className="text-center py-10">Chargement...</p>;
/*
  // Poster un avis
 const handleSubmitAvis = async (e) => {
  e.preventDefault();
  const token = localStorage.getItem("token");

  try {
    setLoadingAvis(true);
    const res = await api.post(
      `/api/avis/service/${service._id}`,
      { 
        commentaire: newAvis,
        note: note // ✅ Envoie la note ou `null`
      },
      { 
        headers: { Authorization: `Bearer ${token}` } 
      }
    );
    console.log("Réponse API après POST :", res.data); // 🔥 Regarde ici !

    setAvis((prev) => [res.data.avis || res.data, ...prev]);
    setNewAvis("");
    setNote(null); // réinitialise
    setMessage("Avis ajouté avec succès !");
    setShowMsg(true);
    setTimeout(() => setShowMsg(false), 3000);
  } catch (err) {
    setMessage(err.response?.data?.msg || "Erreur lors de l'ajout de l'avis");
    setShowMsg(true);
    setTimeout(() => setShowMsg(false), 3000);
  } finally {
    setLoadingAvis(false);
  }
};
*/
  // Réserver un service

  const handleReservation = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setAuthPromptOpen(true);
        return;
      }

      const getRemainingPlaces = async () => {
        const backendRemaining = Number(service?.placesRestantes);
        if (Number.isFinite(backendRemaining) && backendRemaining >= 0) {
          return backendRemaining;
        }

        const countRes = await api.get(`/api/reservations/count/${service._id}`);
        const totalPlaces = getServiceAvailablePlaces(service);
        return Math.max(totalPlaces - (countRes.data.count || 0), 0);
      };

      const currentRemaining = await getRemainingPlaces();

      if (quantite > currentRemaining) {
        const suffixe = currentRemaining > 1 ? "s" : "";
        setMessage(
          currentRemaining > 0
            ? `Il ne reste que ${currentRemaining} place${suffixe} pour ce créneau. Merci de réduire le nombre de participants.`
            : "Ce créneau est complet."
        );
        setShowMsg(true);
        if (currentRemaining > 0) {
          setQuantite(currentRemaining);
        }
        return;
      }

      const selectedDate =
        Array.isArray(service.dateService) && service.dateService[selectedCreneauIndex]
          ? service.dateService[selectedCreneauIndex]
          : null;

      const res = await api.post(
        `/api/services/${service._id}/reserver`,
        { quantity: quantite, selectedDate },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const storedUser = localStorage.getItem("user");
      if (storedUser && res?.data?.user) {
        const oldUser = JSON.parse(storedUser);
        const updatedUser = {
          ...oldUser,
          credits: res.data.user.credits,
        };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        window.dispatchEvent(
          new CustomEvent("creditsUpdated", { detail: updatedUser })
        );
      }

      const updatedRemaining = Number.isFinite(Number(service?.placesRestantes)) && Number(service.placesRestantes) >= 0
        ? Math.max(Number(service.placesRestantes) - quantite, 0)
        : await (async () => {
            const countResAfter = await api.get(`/api/reservations/count/${service._id}`);
            const totalPlacesAfter = getServiceAvailablePlaces(service);
            return Math.max(totalPlacesAfter - (countResAfter.data.count || 0), 0);
          })();

      setPlacesRestantes(updatedRemaining);
      setService((prev) => prev ? { ...prev, placesRestantes: Math.max(Number(prev?.placesRestantes ?? 0) - quantite, 0) } : prev);

      setMessage(quantite > 1 ? `${quantite} réservations confirmées !` : "Réservation confirmée !");
      setShowMsg(true);
    } catch (err) {
      console.error("Erreur réservation :", err);
      if (err.response?.status === 400) {
        try {
          const retryRemaining = await (async () => {
            const backendRemaining = Number(service?.placesRestantes);
            if (Number.isFinite(backendRemaining) && backendRemaining >= 0) {
              return backendRemaining;
            }

            const countRes = await api.get(`/api/reservations/count/${service._id}`);
            const totalPlaces = getServiceAvailablePlaces(service);
            return Math.max(totalPlaces - (countRes.data.count || 0), 0);
          })();
          const suffixe = retryRemaining > 1 ? "s" : "";

          if (retryRemaining < quantite) {
            setMessage(
              retryRemaining > 0
                ? `Il ne reste que ${retryRemaining} place${suffixe} pour ce créneau. Merci de réduire le nombre de participants.`
                : "Ce créneau est complet."
            );
            if (retryRemaining > 0) {
              setQuantite(retryRemaining);
            }
            setShowMsg(true);
            return;
          }
        } catch {
          // Si la vérification échoue, on retombe sur le message backend.
        }
      }

      setMessage(err.response?.data?.msg || "Erreur lors de la réservation");
      setShowMsg(true);
    }
  };


const getDisplayedHour = (rawDate, fallbackHeure) => {
  if (fallbackHeure && /^\d{2}:\d{2}$/.test(String(fallbackHeure))) {
    return String(fallbackHeure).replace(":", "h");
  }

  const match = String(rawDate || "").match(/T(\d{2}:\d{2})/);
  if (match?.[1]) {
    return match[1].replace(":", "h");
  }

  if (rawDate && String(rawDate).includes("T")) {
    return new Date(rawDate)
      .toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })
      .replace(":", "h");
  }

  return "Heure à préciser";
};

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--app-background)' }}>
    <Header />

      {showMsg && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: message.includes("places") || message.includes("Réservation confirmée") || message.includes("confirmée") ? "#ff7500" : (message.includes("succès") ? "green" : "red"),
            color: "white",
            padding: "1rem 2rem",
            borderRadius: "8px",
            zIndex: 1000,
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          {message}
        </div>
      )}

      {authPromptOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(17, 24, 39, 0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: "1rem",
          }}
          onClick={() => setAuthPromptOpen(false)}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "16px",
              padding: "2rem",
              width: "100%",
              maxWidth: "420px",
              boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 style={{ margin: 0, fontSize: "1.4rem", fontWeight: 700, color: "#111827" }}>
              Créez un compte pour réserver
            </h2>
            <p style={{ marginTop: "0.75rem", color: "#4b5563", lineHeight: 1.6 }}>
              Pour réserver ce service, vous devez avoir un compte utilisateur. Rejoignez-nous ou connectez-vous pour continuer.
            </p>
            <div style={{ display: "flex", gap: "0.75rem", marginTop: "1.5rem", flexWrap: "wrap" }}>
              <button
                onClick={() => {
                  setAuthPromptOpen(false);
                  navigate("/register");
                }}
                className="btn-primary"
                style={{ flex: 1, minWidth: "140px" }}
              >
                Créer un compte
              </button>
              <button
                onClick={() => {
                  setAuthPromptOpen(false);
                  navigate("/login");
                }}
                style={{
                  flex: 1,
                  minWidth: "140px",
                  border: "1px solid #d1d5db",
                  backgroundColor: "#fff",
                  color: "#111827",
                  borderRadius: "999px",
                  padding: "0.8rem 1rem",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Se connecter
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="max-w-6xl mx-auto p-6">
        <button
          onClick={() => navigate(-1)}
          className="link-fuchsia mb-4 hover:underline transition-colors"
        >
          ← Retour
        </button>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Colonne gauche */}
          <div className="lg:col-span-2">
            {/* Galerie d'images */}
            <ServiceImageGallery 
              images={service.images}
              title={service.titre}
              compact={false}
              className="rounded-lg mb-4"
            />

            {/* Titre et catégorie */}
            <h1 className="text-2xl font-bold mb-2">{service?.titre || "Chargement..."}</h1>
            

            {/* Créateur */}
            {service?.createur && (
              <div
                className="flex items-center gap-3 mb-4 cursor-pointer group"
                onClick={() => navigate(`/users/${service.createur._id}`)}
                title={`Voir le profil de ${service.createur.prenom} ${service.createur.name}`}
              >
                <UserAvatar
                  photo={service.createur?.photo}
                  name={service.createur?.name}
                  prenom={service.createur?.prenom}
                  alt={`${service.createur?.prenom || ""} ${service.createur?.name || ""}`.trim()}
                  className="w-16 h-16 cursor-pointer flex-shrink-0"
                />
                <div>
                    <h3 className="font-medium text-[var(--accent-primary)] inline-block rounded px-1 transition-colors group-hover:bg-[var(--accent-primary-soft)]">
                      {service.createur.prenom}  {service.createur.name}
                    </h3>
                  
                  {avis.length > 0 ? (
                    <p className="text-sm text-gray-500">{avis.length} témoignage{avis.length > 1 ? "s" : ""}</p>
                  ) : (
                    <p className="text-gray-400 text-sm"></p>
                  )}
    </div>
  </div>
)}

            {/* Description et détails */}
            <div className="bg-white p-6 rounded-lg shadow mb-6">
              <h2 className="text-lg font-semibold mb-3">Description</h2>
              <p className="text-gray-700 mb-4 whitespace-pre-line">{service.description}</p>

              {service.programme && (
                <ul className="list-disc list-inside text-gray-700 space-y-1">
               
                  {service.programme.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              )}
              {/* Catégories sous forme de tags */}
{Array.isArray(service.categories) && service.categories.length > 0 && (
  <div className="flex flex-wrap gap-2 mb-4">
    {[...new Set(service.categories.filter((cat) => cat && String(cat).trim() !== "Autres"))].map((cat, index) => (
      <span
        key={index}
        className="px-3 py-1 rounded-full text-xs font-semibold border border-[var(--accent-primary)] bg-[var(--accent-primary-soft)] text-[var(--accent-primary)]"
      >
        #{cat}
      </span>
    ))}
  </div>
)}




              <br />
              <h2 className="text-lg font-semibold mb-4">Détails du service</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
                <div className="flex items-center gap-2">
                  <FaMapMarkerAlt className="text-[var(--accent-primary)]" />
                  <span>
                    <strong>Lieu :</strong> {service.lieu || "Non renseigné"}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <FaClock className="text-[var(--accent-primary)]" />
                  <span>
                    <strong>Durée :</strong> {service.duree || "Non renseignée"}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <FaUser className="text-[var(--accent-primary)]" />
                  <span>
                    <strong>Type de séance :</strong>{" "}
                    {service.typeCours || "Non renseigné"}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <FaUser className="text-[var(--accent-primary)]" />
                  <span>
                    <strong>Public cible :</strong> {service.publicCible || "Non renseigné"}
                  </span>
                </div>
                {service.typeCours === "Collective" && service.nombrePersonnesMaxAtelier && (
                  <div className="flex items-center gap-2">
                    <FaUsers
                      className="text-[var(--accent-primary)]"
                      style={{ color: "var(--accent-primary)" }}
                    />
                    <span>
                      <strong>Nombre de personnes max par atelier :</strong>{" "}
                      {service.nombrePersonnesMaxAtelier}
                    </span>
                  </div>
                )}

                <div className="flex items-center gap-2">
                  <FaUser className="text-[var(--accent-primary)]" />
                  <span>
                    <strong>Type de prestation:</strong> {service.typePrestation || "Non renseigné"}
                  </span>
                </div>
                {serviceCapacityValue !== null && serviceCapacityValue > 0 && (
                  <div className="flex items-center gap-2">
                    <FaUsers className="text-[var(--accent-primary)]" />
                    <span>
                      <strong>Capacité maximale :</strong> {serviceCapacityValue}
                    </span>
                  </div>
                )}
                <div className="flex items-center gap-2">
                  <FaWheelchair className="text-[var(--accent-primary)]" />
                  <span>
<strong>Accessibilité PMR :</strong>{" "}
{service.accessiblePMR ? "Oui" : "Non"}

{service.accessiblePMR && service.pmrDetails && (
  <span> ({service.pmrDetails})</span>
)}
            


                  </span>
                </div>
              </div>

              <hr className="my-4" />
              <div className="space-y-3">
                <div className="flex items-start gap-2">
                  <FaCheckCircle className="text-[var(--accent-primary)] mt-1" />
                  <p>
                    <strong>Prérequis :</strong> {service.prerequis || "Aucun prérequis"}
                  </p>
                </div>
                <div className="flex items-start gap-2">
                  <FaClipboardList className="text-[var(--accent-primary)] mt-1" />
                  <p>
                    <strong>Matériel nécessaire :</strong> {service.materiel || "Aucun matériel requis"}
                  </p>
                </div>
              </div>
            </div>

            {/* Formulaire pour poster un avis */}
           {/* Formulaire pour poster un avis */}
           {/*
<div className="bg-white p-6 rounded-lg shadow mb-6">
  <h2 className="text-lg font-semibold mb-3">Poster un avis</h2>
  <form onSubmit={handleSubmitAvis}>
    
    <label className="block mb-1 text-sm text-gray-600">
      Note (optionnelle)
    </label>
          {renderStarRating()}

    <textarea
      value={newAvis}
      onChange={(e) => setNewAvis(e.target.value)}
      placeholder="Écrivez votre avis ici..."
      className="w-full border rounded p-2 mb-3"
      rows={3}
      required
    />

    <button
      type="submit"
      disabled={loadingAvis}
      className="btn-primary py-2 px-4"
    >
      {loadingAvis ? "Envoi..." : "Poster l'avis"}
    </button>
  </form>
</div>
*/}
            {/* Liste des avis */}
            
          </div>

          {/* Colonne droite : réservation */}
          <div className="bg-white p-6 rounded-lg shadow h-fit">
            <p className="credits-fuchsia font-bold text-lg mb-2">
              {service.creditsProposes} crédits / participant
            </p>

            {/* Sélection du nombre de participants */}
            <div className="flex items-center gap-3 mb-4">
              <span className="text-gray-700 text-sm font-medium">Participants :</span>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setQuantite(q => Math.max(1, q - 1))}
                  className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center text-lg font-bold hover:bg-gray-100 transition-colors"
                  aria-label="Diminuer"
                >−</button>
                <span className="w-6 text-center font-semibold">{quantite}</span>
                <button
                  onClick={() => setQuantite(q => q + 1)}
                  className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center text-lg font-bold hover:bg-gray-100 transition-colors"
                  aria-label="Augmenter"
                >+</button>
              </div>
            </div>
            {quantite > 1 && (
              <p className="text-sm text-gray-500 mb-2">
                Total : <span className="credits-fuchsia font-semibold">{service.creditsProposes * quantite} crédits</span>
              </p>
            )}

            <button
              onClick={handleReservation}
              className="w-full btn-primary py-2 mb-6"
            >
              Réserver ce service
            </button>

            <h3 className="flex items-center font-semibold mb-3">
              <FaCalendarAlt className="text-[var(--accent-primary)] mr-2" />
              Créneaux disponibles
            </h3>
            
 <div className="space-y-2">
  {service.dateAConvenir === true ? (
  <div className="flex items-center gap-2 border p-3 rounded bg-gray-50">
    <FaCalendarAlt className="text-[var(--accent-primary)]" />
    <span className="font-medium text-gray-800">
      Date et heure de rdv à convenir ensemble
    </span>
  </div>
) : Array.isArray(service.dateService) && service.dateService.length > 0 ? (
    service.dateService.map((date, index) => (
      <div
        key={index}
        onClick={() => setSelectedCreneauIndex(index)}
        className={`flex justify-between items-center border p-2 rounded cursor-pointer transition-colors ${selectedCreneauIndex === index ? "border-[var(--accent-primary)] bg-orange-50" : "hover:bg-gray-50"}`}
      >
        <div className="flex flex-col">
          <span className="text-black">
            {new Date(date).toLocaleDateString("fr-FR")}
          </span>
          <span className="text-gray-500">
            {getDisplayedHour(date, service.heure)}
          </span>
        </div>
        <div className="text-right text-sm">
          <p className="text-gray-500">Places restantes</p>
          <p className="font-semibold text-[var(--accent-primary)]">
            {placesRestantes} / {Number(service?.nombrePlaces) || Number(service?.capaciteMaximale) || getServiceAvailablePlaces(service) || 0}
          </p>
        </div>
      </div>
    ))
  ) : (
    <div className="flex items-center gap-2 border p-3 rounded bg-gray-50">
      <FaCalendarAlt className="text-gray-400" />
      <span className="italic text-gray-500">
        Aucun créneau renseigné
      </span>
    </div>
  )}
</div>



          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServiceDetail;


